import { ActivityFeedback } from "PFTypes/activity_feedback";
import { FeedbackSkill } from "PFTypes/activity_participant";
import { createContext, useContext } from "react";

export type FeedbackFormData = Omit<ActivityFeedback, "skills" | "role" | "recipient" | "provider"> & {
  skills: SkillToRank[];
};

export type SkillToRank = FeedbackSkill & { isActive?: boolean };

export type FeedbackFormContextProps = {
  onUpdate?: (formData: FeedbackFormData | null) => void;
  defaultData: FeedbackFormData | undefined;
};

export type FeedbackFormContext = {
  setFormData: React.Dispatch<React.SetStateAction<FeedbackFormData | undefined>>;
  formData: FeedbackFormData | undefined;
  errors: Record<number, string | string[]>;
  setErrors: React.Dispatch<React.SetStateAction<Record<number, string | string[]>>>;
};

export const FeedbackFormContext = createContext({} as FeedbackFormContext);

export const useFeedbackFormContext = () => useContext(FeedbackFormContext);
